import React from 'react'

export const ButtonGroup: React.FC = ({children}) => (
  <div className="relative z-0 inline-flex -space-x-px">{children}</div>
)
